import style from "./loaders.module.css";

export function SimpleSpinner() {
  return <div className={style.loader} />;
}
